import * as React from "react";
import { SVGProps } from "../types";

const SberBankIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <circle cx="16" cy="16" r="14" fill="#299D37"></circle>
    <path
      fill="#fff"
      d="m22.932 9.014-.858-.776-9.988 5.653-4.761-2.693-.49.97 5.25 3.01z"
    ></path>
    <path
      fill="#fff"
      d="M21.043 7.582 19.889 7l-7.803 4.44-3.46-1.965-.712.85 4.172 2.353z"
    ></path>
    <path
      fill="#fff"
      d="m24.331 10.664-.638-.85-11.607 6.6-5.644-3.202-.27 1.068 5.914 3.348z"
    ></path>
    <path
      fill="#fff"
      d="M26 16.1q0-1.65-.54-3.155l-.54-1.359-12.834 7.28L6 15.444v.655q0 1.99.785 3.859a9.6 9.6 0 0 0 2.135 3.155 10.3 10.3 0 0 0 3.166 2.086Q13.95 26 15.988 26a9.9 9.9 0 0 0 3.902-.8 9.9 9.9 0 0 0 3.19-2.087 10.1 10.1 0 0 0 2.135-3.155l.245-.656Q26 17.75 26 16.1"
    ></path>
  </svg>
);

export { SberBankIcon };
